<template>
  <div>
    <!-- 自身模块 -->
    <div class="banner self-banner">
      <!-- <div class="banner-title">通用文本识别演示</div>
      <div class="banner-introduce">
        可精准检测出不同场景图片中的文本，实现快速定位识别。整体识别准确率业内领先，可提供多场景、多语种、高精度的整图文字检测和识别服务。
      </div> -->
      <div class="banner-content">
        <div class="inner">
          <div class="ocr">
            <div class="left">
              <ocrLeft
                :ocrUrl="ocrUrl"
                :preview_img="preview_img"
                @getOcrResult="getOcrResult"
                :coordinate="coordinate"
                :imgIndex="imgIndex"
                :canvas_rotate="canvas_rotate"
                :ocr_id="reco_id"
              ></ocrLeft>
            </div>
            <div class="right">
              <el-collapse v-model="activeNames" accordion>
                <el-collapse-item name="1">
                  <template slot="title">
                    <div class="title">
                      <img :src="require('../../assets/img/tb.png')" alt="" />
                      <span>识别结果</span>
                    </div>
                  </template>
                  <template v-if="resp_data">
                    <div class="result">
                      <div class="content">
                        <div class="item">
                          <span class="name" style="width: 120px">是否为活体</span>
                          <span class="val">{{ resp_data.result.result ? '是' : '否' }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <ocrNoResult v-else></ocrNoResult>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template slot="title">
                    <div class="title">
                      <img :src="require('../../assets/img/tb2.png')" alt="" />
                      <span>Response JSON</span>
                    </div>
                  </template>
                  <ocrResult :resp_data="resp_data"></ocrResult>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ocrLeft from "../../components/ocr-left.vue";
import ocrResult from "../../components/ocr-result.vue";
import ocrNoResult from "../../components/ocr-no-result.vue";

import preview_data from "../../../static/preview_data/v3_liveness.js";

export default {
  components: {
    ocrLeft,
    ocrResult,
    ocrNoResult,
  },
  data() {
    return {
      activeNames: ["1"],
      tables: [],
      resp_data: "",
      coordinate: [],
      preview_img: [],
      imgIndex: 0, // 当前显示的哪个图片
      canvas_rotate: 0
    };
  },
  computed: {
    ocrUrl() {
      // return this.$menuData[0].childs.general_text.ocr_url;
      return "api/reco/all";
    },
    reco_id(){
      return this.$menuData[5].childs.liveness.reco_id;
    }
  },
  methods: {
    changeIndex(index) {
      this.imgIndex = index;
    },

    getOcrResult(result) {
      this.resp_data = result.resp_data;

      if(!result.isMemory){
        this.preview_img.push(result.up_imgBase64);
        this.imgIndex = this.preview_img.length - 1;
      }else{
        this.imgIndex = result.imgIndex;
      }

      this.canvas_rotate = Number(
        result.resp_data.rotation !== undefined ? -result.resp_data.rotation : 0
      );
    },

    resultMouseClick(data) {
      this.coordinate = {
        index: this.imgIndex,
        coordinate: data.quad.split(","),
      };
    },
  },
  mounted() {
    this.resp_data = preview_data;
    this.preview_img = [
      require("../../../static/preview_img/face2.jpeg"),
    ];
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/face/v3_liveness.vue